import { CITATIONS, GUIDES, PLAGIARISM, SIGN_IN } from '@chegg-wt/core/constants/nav'
import { Config } from '@chegg-wt/core/config'
import { NavItem } from '@chegg-wt/core/types/core'

export const HOME_PAGE_HEADER_TEST = 'home-page-header-test'

export const headerNavigationItems: NavItem[] = [
  {
    name: CITATIONS,
    route: 'toProject',
    hideOnMobile: true,
  },
  {
    name: PLAGIARISM,
    route: 'toWritingAssistant',
    hideOnMobile: true,
  },
  {
    name: GUIDES,
    href: Config.guidesUrl,
    hideOnMobile: true,
  },
]

export const headerAccountItems: NavItem[] = [
  {
    name: SIGN_IN,
    hideOnMobile: true,
  },
]
